export default "__VITE_ASSET__N2nPIwZ9__"